import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { t_medical_institution } from 'types';
import { getDataStoreFieldMedicals, medicalNewItem } from './thunk';

interface InitialState {
  medicalInstitution: t_medical_institution;
  dataStoreMedicalFields?: any[];
}

const initialState: InitialState = {
  medicalInstitution: {},
};

const MedicalSlice = createSlice({
  name: 'medical',
  initialState,
  reducers: {
    newMedical(state, action: PayloadAction<t_medical_institution>) {
      return { ...state, medicalInstitution: action.payload };
    },
    resetState(state) {
      return { ...state, medicalInstitution: {} };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(medicalNewItem.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
    builder.addCase(getDataStoreFieldMedicals.fulfilled, (state, action) => ({
      ...state,
      dataStoreMedicalFields: Object.entries(action.payload.data.fields),
    }));
  },
});

export const { newMedical, resetState } = MedicalSlice.actions;

export default MedicalSlice.reducer;
